import React from 'react';
import { Card } from '../ui/card';

/** Shared Shadcn card wrapper for home analytics widgets. */
const ChartCard = ({ title, subtitle, action, loading, isEmpty, emptyText = 'No data yet', className = '', testid, children }) => (
  <Card className={`p-5 ${className}`} data-testid={testid}>
    <div className="flex items-start justify-between mb-4">
      <div>
        <h3 className="text-base font-semibold tracking-tight text-slate-800">{title}</h3>
        {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
      {action}
    </div>
    {loading ? (
      <div className="h-[260px] rounded-md bg-slate-100 animate-pulse" />
    ) : isEmpty ? (
      <div className="h-[260px] flex items-center justify-center text-sm text-slate-400">{emptyText}</div>
    ) : (
      children
    )}
  </Card>
);

export default ChartCard;
